import type { TPeersMethod } from "@/types"

export const PEERS_METHODS: { label: string; value: TPeersMethod }[] = [
  { label: "All employees", value: "all" },
  { label: "Choose members", value: "manual" },
  { label: "Own departments", value: "teammates" },
  { label: "Manager & reports", value: "manager" },
  { label: "Self review", value: "self" },
]

export const PEERS_METHODS_HELP: Record<TPeersMethod, string> = {
  all: "Each employee evaluates every other employee in the company.",
  teammates: "Employees evaluate colleagues from their own departments only.",
  manager: "Each person evaluates their manager, direct reports, and their manager's reports.",
  manual: "Select specific employees and/or departments to evaluate.",
  self: "Employees only evaluate themselves.",
}
